import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  clearCaseLogs,
  getCaseLogsByCaseId,
} from "../../store/common/loggingSlice";

const CaseLogs: React.FC = () => {
  const dispatch = useAppDispatch();
  const { logs, error, isLoading } = useAppSelector((state) => state.logging);

  const { case_id } = useParams<{ case_id: string }>();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  useEffect(() => {
    if (case_id && tab === "caseLogs") {
      dispatch(getCaseLogsByCaseId(case_id));
    }
    return () => {
      dispatch(clearCaseLogs());
    };
  }, [case_id, tab, dispatch]);

  if (!case_id) return <div className="p-4"> Invalid case ID.</div>;
  if (isLoading) return <div className="p-4">Loading case logs...</div>;
  if (error) return <div className="p-4 text-red-600">Error: {error}</div>;

  return (
    <div className="p-4">
      {logs.length === 0 ? (
        <p className="text-gray-500">No logs found for this case.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 rounded-lg text-sm">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="px-4 py-2 border-b break-words whitespace-normal">
                  #
                </th>
                <th className="px-4 py-2 border-b break-words whitespace-normal min-w-[10vw]">
                  Action
                </th>
                <th className="px-4 py-2 border-b break-words whitespace-normal min-w-[10vw]">
                  User
                </th>
                <th className="px-4 py-2 border-b break-words whitespace-normal min-w-[30vw]">
                  Description
                </th>
                <th className="px-4 py-2 border-b break-words whitespace-normal">
                  Time
                </th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, index) => (
                <tr key={log.id} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-2 break-words whitespace-normal">
                    {index + 1}
                  </td>
                  <td className="px-4 py-2 break-words whitespace-normal min-w-[10vw]">
                    {log.title}
                  </td>
                  <td className="px-4 py-2 break-words whitespace-normal min-w-[10vw]">
                    {log.By}
                  </td>
                  <td className="px-4 py-2 break-words whitespace-normal min-w-[30vw]">
                    {log.body}
                  </td>
                  <td className="px-4 py-2 break-words whitespace-normal">
                    {new Date(log.creation_ts).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CaseLogs;
